import * as Sentry from "@sentry/react";
import { type ErrorComponentProps } from "@tanstack/react-router";
import { isAxiosError } from "axios";
import { useEffect } from "react";

import { SnackbarProvider } from "@/contexts/SnackbarContext";
import { SignInError } from "@/errors/SignInError";
import { CommonTrackingEvents, rudderAnalytics } from "@/lib/rudderstack";

import { GeneralPageError } from "./GeneralPageError";
import { NoNetworkConnectionPageError } from "./NoNetworkConnectionPageError";
import { SignInErrorMessage } from "./SignInErrorMessage";

export const DefaultErrorComponent = ({ error }: ErrorComponentProps) => {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  useEffect(() => {
    rudderAnalytics.track(CommonTrackingEvents.UNEXPECTED_CLIENT_ERROR);
  }, []);

  return (
    <SnackbarProvider>
      {isAxiosError(error) && error.code === "ERR_NETWORK" ? (
        <NoNetworkConnectionPageError />
      ) : error instanceof SignInError ? (
        <SignInErrorMessage error={error} />
      ) : (
        <GeneralPageError />
      )}
    </SnackbarProvider>
  );
};
